import * as React from 'react';

import { CUSTOMER_SERVICE_NAME } from '@acceligentllc/shared/constants/value';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

interface OwnProps {
	close: () => void;
	show: boolean;
	userFullName: Nullable<string>;
}

type Props = OwnProps;

const ForcedUnlockNotificationModal: React.FC<Props> = (props: Props) => {
	const {
		close,
		show,
		userFullName,
	} = props;

	return (
		<CustomModal
			closeModal={close}
			modalStyle="warning"
			showModal={show}
			size="md"
		>
			<CustomModal.Header
				closeModal={close}
				title="Session Canceled"
			/>
			<CustomModal.Body>
				<p>{userFullName ?? CUSTOMER_SERVICE_NAME} terminated your Work Order Edit session.</p>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Understood"
					onClick={close}
					style="secondary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

export default ForcedUnlockNotificationModal;
